const NO_WINDOW = { startTimestamp: 0, endTimestamp: 0 };

const SECONDS_PER_DAY = 86400;

function startOfLocalDay(timestamp) {
  const day = new Date(Number(timestamp) * 1000);

  day.setHours(0, 0, 0, 0);

  return Math.floor(day.getTime() / 1000);
}

function atTimeOnDay(dayStartTimestamp, timeOfDay, fallback) {
  const [hours, minutes] = String(timeOfDay || fallback).split(":");
  const day = new Date(dayStartTimestamp * 1000);

  day.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

  return Math.floor(day.getTime() / 1000);
}

function getOccurrenceWindow(event) {
  const occurrenceStart = Number(event && event.occurrenceStart) || 0;

  if (!occurrenceStart) {
    return { ...NO_WINDOW };
  }

  const dayStart = startOfLocalDay(occurrenceStart);

  const startTimestamp = event.isAllDay
    ? dayStart
    : atTimeOnDay(dayStart, event.startTime, "09:00");

  const endTimestamp = event.isAllDay
    ? dayStart + SECONDS_PER_DAY - 1
    : atTimeOnDay(dayStart, event.endTime, "17:00");

  const isUnmoved = startTimestamp === Number(event.startTimestamp)
    && endTimestamp === Number(event.endTimestamp);

  if (isUnmoved) {
    return { ...NO_WINDOW };
  }

  return { startTimestamp, endTimestamp };
}

module.exports = {
  getOccurrenceWindow,
};
